import request from '@/config/request';
import API from '@/config/domain';

export default {
  // 登录时间统计 - 列表
  queryUserList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/queryUserList', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 登录时间统计 - 查看登录详情
  getUserSessionDetail(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/getUserSessionDetail', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 登录时间统计-导出
  exportUserList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/exportUserList', 'post', params, '', 'blob').then((data) => {
      callback(data);
    })
  },
  // 日志管理-列表
  getAuditLogList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/auditLog/getAuditLogList', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 通知公告列表-列表
  pageDrugMessageNotice(params, callback) {
    return request(API.BASEAPI + 'rest/drugMessageNotice/pageDrugMessageNotice', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 通知公告列表-机构树加载
  loadOrgByParentId(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/loadOrgDataAll', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 通知公告列表-通知公告保存
  saveDrugMessageNotice(params, callback) {
    return request(API.BASEAPI + 'rest/drugMessageNotice/saveDrugMessageNotice', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 通知公告列表-通知公告详情
  getDrugMessageNotice(params, callback) {
    return request(API.BASEAPI + 'rest/drugMessageNotice/getDrugMessageNotice', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 通知公告列表-数据删除
  deleteDrugMessageNotice(params, callback) {
    return request(API.BASEAPI + 'rest/drugMessageNotice/deleteDrugMessageNotice', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 通知公告列表-发布状态修改
  updateDrugMessageNoticeStatus(params, callback) {
    return request(API.BASEAPI + 'rest/drugMessageNotice/updateDrugMessageNoticeStatus', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 附件上传
  uploadFileEnCode(params, callback) {
    return request(API.BASEAPI + 'rest/data/uploadFileEnCode', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 附件下载接口
  downLoadFileByUrl(params, callback) {
    return request(API.BASEAPI + 'rest/data/downLoadFileByUrl', 'post', params, '', 'blob').then((data) => {
      callback(data);
    })
  },
};